<div class="row">
  <div class="col s12 m6">
    <h4 class="card-title">Usage Tracking</h4>
  </div>
  <div class="col s12 m6 right-align">
    <!-- <a (click)="dataExportCsv()" *ngIf="!isLoading" class="waves-effect waves-light grey lighten-1 btn mb-1" style="min-width: 158px;">
      <i class="material-icons right">format_list_bulleted</i> Export CSV
    </a> -->
    <div *ngIf="isLoading">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col s12 m4">
    <input [(ngModel)]="selectedMoment" [owlDateTime]="dt1" [selectMode]="'range'" [owlDateTimeTrigger]="dt1" placeholder="Date Time" style="width: 300px;">
    <span class="trigger" [owlDateTimeTrigger]="dt1">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>    
  </div>
  <div class="col s12 m2">
    <label>
      <!-- <input (change)="areaConfigChange('area.occupancy')" type="checkbox" [(ngModel)]="tArea.isOccupancyArea" /> -->
      <input (change)="showHideSysUsers()" type="checkbox" [checked]="true" [(ngModel)]="chkBox">
      <span>Show System Users</span>
   </label>
    
  </div>
  <div class="col s12 m4">
    <input [(ngModel)]="name" id="txtName" name="txtEmail" type="text" placeholder="Search for Name or Code">
  </div>
  <div class="col s12 m2 right-left">
    <a (click)="dateChange()" *ngIf="!isLoading" class="waves-effect waves-light gradient-45deg-green-teal btn ml-1" style="min-width: 158px;">
      View Data
    </a>
  </div>
</div>
<div>
  <div class="row">
    <div class="col s12 m12 14">
      <div class="card animate fadeleft">
        <div class="card-content">
          <h4 class="card-title mb-0">Usage</h4>
         
          <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
            <canvas #chtBarUsage></canvas>
          </div>
          <!-- <div class="chart-container" style="position: relative; height:200px; width:100%">    
            <canvas id="canvas">{{chtUsage}}</canvas>    
          </div>   -->
        </div>
      </div>
    </div>
</div>
<div class="row">  
  <div class="col s12 m12 l12" *ngIf="usage">
    <table style="width:100%;">
      <!-- <thead> -->
        <tr>
          <th style="width: 25%;">Name</th>
          <th style="width: 25%;">Code</th>
          <!-- <th style="width: 20%;">Action Code</th> -->
          <th style="width: 25%;">Date</th>
          <th style="width: 25%;">Remark</th>
        </tr>
      <!-- </thead> -->
        <ng-container *ngFor="let rec of usage.data">
          <tr *ngIf="!chkBox && (rec.role!='SA' && rec.role!='GEEK')">
            <td  style="text-align: left;">{{rec.name}}</td>
            <td  style="text-align: left;">{{rec.code}}</td>
            <!-- <td  style="text-align: left;">{{rec.actionCode}}</td> -->
            <!-- <td  style="text-align: left;">{{rec.timestampUtc}}</td> -->
            <td style="text-align: left;">{{ rec.timestampUtc | date:'dd.MM.yyyy HH:mm' }}</td>
            <td  style="text-align: left;">{{rec.role}}</td>
          </tr>
        </ng-container>
        
        <ng-container *ngFor="let rec of usage.data">
          <tr *ngIf="chkBox">
            <td  style="text-align: left;">{{rec.name}}</td>
            <td  style="text-align: left;">{{rec.code}}</td>
            <td style="text-align: left;">{{ rec.timestampUtc | date:'dd.MM.yyyy HH:mm' }}</td>
            <td  style="text-align: left;">{{rec.role}}</td>
          </tr>
        </ng-container>
       
     
    </table>
  </div>
</div>
